/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { elementIdSchema } from "../elementIdSchema.ts";
import { propertyUpdateSchema } from "../propertyUpdateSchema.ts";
import { z } from "zod";

export const createPropertyServicePathParamsSchema = z.object({
      "codeNs": z.string().describe("Code Notariat Service de l'étude associée à l'annonce.")
      })

export const createPropertyServiceQueryParamsSchema = z.object({
      "email": z.string().describe("Adresse email du négociateur associé à l'annonce.").optional()
      }).optional()

/**
 * @description Annonce traitée avec succès.
 */
export const createPropertyService201Schema = z.lazy(() => elementIdSchema).describe("Identifiant d'un élément.")

/**
 * @description error occurred - see status code and problem object for more information.
 */
export const createPropertyService400Schema = z.object({
      "type": z.string().url().default("about:blank").describe("An absolute URI that identifies the problem type. When dereferenced,\nit SHOULD provide human-readable documentation for the problem type\n(e.g., using HTML).\n"),
  "title": z.string().describe("A short, summary of the problem type. Written in english and readable\nfor engineers (usually not suited for non technical stakeholders and\nnot localized); example: Service Unavailable\n").optional(),
  "status": z.number().int().min(100).max(600).describe("The HTTP status code generated by the origin server for this occurrence\nof the problem.\n").optional(),
  "detail": z.string().describe("A human readable explanation specific to this occurrence of the\nproblem.\n").optional(),
  "instance": z.string().url().describe("An absolute URI that identifies the specific occurrence of the problem.\nIt may or may not yield further information if dereferenced.\n").optional(),
  "properties": z.object({
      
      }).catchall(z.any()).describe("Additional properties that can be used to store any additional information\nabout the problem. This is useful for providing more context or details\nabout the error.\n").optional()
      })

export const createPropertyServiceMutationRequestSchema = z.lazy(() => propertyUpdateSchema).describe("État complet du bien : un sous-objet absent (prix, adresse) est supprimé. Exception : les valeurs enregistrées\nque la nature enregistrée ou la nouvelle ne propose pas (sous-nature, typologie, commodités, chauffages,\néquipements, DPE), d'après form-rules/property-form.json, ne sont pas supprimées par leur absence ; masquées à\nla lecture (fiche et liste), elles réapparaissent si le bien revient à une nature qui les propose.\nDPE (`energies`) : absent, l'historique est inchangé ; liste fournie, elle remplace l'historique (`[]` le vide)\nquand la nature enregistrée et la nouvelle comportent des DPE. Une liste non vide est refusée (400) quand l'une\ndes deux n'en comporte pas : le changement de nature s'enregistre d'abord.\nVaut pour PUT /property/{id} et PUT /service/property/{codeNs}/{id}.\n")

export const createPropertyServiceMutationResponseSchema = z.lazy(() => createPropertyService201Schema)